import { Inject, Injectable } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    ConfirmationMaterialConsumeModel,
    CONSUME_CODE,
    MaterialModel,
} from '@evorait/pace-core';

@Injectable({
    providedIn: 'root',
})
export class ConfirmationMaterialConsumeUtilitiesService {
    public constructor(@Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface) {}
    public showComplaintPart(material: MaterialModel, model: ConfirmationMaterialConsumeModel): boolean {
        return (
            this.clientManager.isNgmP58() &&
            model.notification.processIndicator === ConfigConstants.PROCESS_INDICATOR.INVIVO &&
            this.isMaterialConsumed(material) &&
            (model.showComplaintFieldBasedOnUserStatus || model.isOptionYesSelectedInComplaints)
        );
    }

    public isMaterialConsumed(material: MaterialModel): boolean {
        return material.consumptionCode.selectedEntry?.value === CONSUME_CODE.CONSUMED;
    }
}
